const CORE_RULES_CONFIG = {
  desbalanceThresholdPct: 0.5,
  resumenMinConfidence: 0.75,
  resumenMaxDuplicateRatio: 0.5,
  shadowBillingMinCoveragePct: 70,
  shadowBillingMinMatchedCuits: 4,
  certaintyWeights: {
    FACTUAL: 100,
    INFERRED: 70,
    CORRUPT: 30,
  },
}

export default CORE_RULES_CONFIG
